import { Component, Input, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'AppsIllustration',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      [ngClass]="[
        'flex-none z-10 relative h-[300px] w-[320px] text-blue-500',
        class()
      ]"
      >
      @if (secondAppIcon) {
        <div
        class="
          bg-white p-6 shadow-2xl absolute right-0 top-0 center flex-col
          w-[180px] h-[200px]
          rounded-xl
        "
          >
          <img
            class="w-20 h-20 mb-4"
            src="assets/images/apps/{{ secondAppIcon }}.svg"
            />
          <h4 class="text-base">
            {{ secondAppName() }}
          </h4>
        </div>
      }
    
      @if (secondAppIcon === null) {
        <div
        class="
          bg-blue-200 p-6 shadow-2xl absolute right-0 top-0 center flex-col
          w-[180px] h-[200px]
          rounded-xl
        "
          >
          <div
          class="
            bg-blue-500 rounded-full center shadow-xl shadow-blue-500/50
            w-18 h-18
          "
            >
            <svg
              class="text-blue-500 w-2/5 h-2/5"
              viewBox="0 0 30 30"
              xmlns="http://www.w3.org/2000/svg"
              >
              <g
                stroke="currentColor"
                stroke-width="4"
                fill="none"
                fill-rule="evenodd"
                >
                <path d="M0 15.5h30M15.5 0v30" />
              </g>
            </svg>
          </div>
        </div>
      }
    
      <div
        class="
          bg-white p-6 shadow-2xl absolute left-0 bottom-0 center flex-col
          w-[180px] h-[200px]
          rounded-xl
        "
        >
        <img
          class="w-20 h-20 mb-4"
          src="assets/images/apps/{{ appIcon() }}.svg"
          />
        <h4 class="text-base">{{ appName() }}</h4>
      </div>
    
      <svg
        class="absolute left-20 top-10"
        height="60"
        viewBox="0 0 60 60"
        width="60"
        xmlns="http://www.w3.org/2000/svg"
        >
        <clipPath id="a"><path d="m60 0v60h-60v-60z" /></clipPath>
        <g
          clip-path="url(#a)"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          >
          <path
            d="m30 0h130c16.568542 0 30 13.4314575 30 30v140c0 16.568542-13.431458 30-30 30h-130c-16.5685425 0-30-13.431458-30-30v-140c0-16.5685425 13.4314575-30 30-30z"
            stroke-dasharray="5 5"
            stroke-linejoin="round"
            transform="matrix(0 1 -1 0 207 7)"
            />
          <g stroke-miterlimit="10">
            <path d="m.5 0v14" transform="translate(6.5 46)" />
            <path d="m0 0 6 8 6-8" transform="matrix(0 -1 1 0 52 13)" />
            <path d="m.5 0v14" transform="matrix(0 -1 1 0 46 7.5)" />
            <path d="m0 0 6 8 6-8" transform="translate(1 52)" />
          </g>
        </g>
      </svg>
    
      <svg
        class="absolute right-20 bottom-10"
        height="60"
        viewBox="0 0 60 60"
        width="60"
        xmlns="http://www.w3.org/2000/svg"
        >
        <clipPath id="a"><path d="m60 0v60h-60v-60z" /></clipPath>
        <g
          clip-path="url(#a)"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          >
          <path
            d="m30 0h130c16.568542 0 30 13.4314575 30 30v140c0 16.568542-13.431458 30-30 30h-130c-16.5685425 0-30-13.431458-30-30v-140c0-16.5685425 13.4314575-30 30-30z"
            stroke-dasharray="5 5"
            stroke-linejoin="round"
            transform="matrix(0 -1 1 0 -147 53)"
            />
          <g stroke-miterlimit="10">
            <path d="m.5 0v14" transform="matrix(-1 0 0 -1 53.5 14)" />
            <path d="m0 0 6 8 6-8" transform="matrix(0 1 -1 0 8 47)" />
            <path d="m.5 0v14" transform="matrix(0 1 -1 0 14 52.5)" />
            <path d="m0 0 6 8 6-8" transform="matrix(-1 0 0 -1 59 8)" />
          </g>
        </g>
      </svg>
    </div>
    `,
})
export class AppsIllustration {
  readonly class = input<string>('');
  readonly appIcon = input<string | null>(null);
  readonly appName = input<string | null>(null);
  @Input() secondAppIcon: string | null = null;
  readonly secondAppName = input<string | null>(null);
}
